import {IndustryDataType, sectionId} from 'models';

import SCIENCE_IMAGE from "../assets/business-education-assets/industry/science_image.png";
import SCIENCE_IMAGE_2 from "../assets/business-education-assets/industry/science_image_2.png";
import SCIENCE_IMAGE_3 from "../assets/business-education-assets/industry/science_image_3.png";
import AGRICULTURE_IMAGE from "../assets/business-education-assets/industry/agriculture_image.png";
import AGRICULTURE_IMAGE_2 from "../assets/business-education-assets/industry/agriculture_image_2.png";
import AGRICULTURE_IMAGE_3 from "../assets/business-education-assets/industry/agriculture_image_3.png";
import BUSINESS_IMAGE from "../assets/business-education-assets/industry/business_image.png";
import BUSINESS_IMAGE_2 from "../assets/business-education-assets/industry/business_image_2.png";
import BUSINESS_IMAGE_3 from "../assets/business-education-assets/industry/business_image_3.png";
import CONSTRUCTION_IMAGE from "../assets/business-education-assets/industry/construction_image.png";
import CONSTRUCTION_IMAGE_2 from "../assets/business-education-assets/industry/construction_image_2.png";
import CONSTRUCTION_IMAGE_3 from "../assets/business-education-assets/industry/construction_image_3.png";
import FOOD_IMAGE from "../assets/business-education-assets/industry/food_image.png";
import FOOD_IMAGE_2 from "../assets/business-education-assets/industry/food_image_2.png";
import FOOD_IMAGE_3 from "../assets/business-education-assets/industry/food_image_3.png";
import TOURISM_IMAGE from "../assets/business-education-assets/industry/tourism_image.png";
import TOURISM_IMAGE_2 from "../assets/business-education-assets/industry/tourism_image_2.png";
import TOURISM_IMAGE_3 from "../assets/business-education-assets/industry/tourism_image_3.png";
import MANUFACTURER_IMAGE from "../assets/business-education-assets/industry/manufacturer_image.png";
import MANUFACTURER_IMAGE_2 from "../assets/business-education-assets/industry/manufacturer_image_2.png";
import MANUFACTURER_IMAGE_3 from "../assets/business-education-assets/industry/manufacturer_image_3.png";
import FITNESS_IMAGE from "../assets/business-education-assets/industry/fitness_image.png";
import FITNESS_IMAGE_2 from "../assets/business-education-assets/industry/fitness_image_2.png";
import FITNESS_IMAGE_3 from "../assets/business-education-assets/industry/fitness_image_3.png";
import FASHION_IMAGE from "../assets/business-education-assets/industry/fashion_image.png";
import FASHION_IMAGE_2 from "../assets/business-education-assets/industry/fashion_image_2.png";
import FASHION_IMAGE_3 from "../assets/business-education-assets/industry/fashion_image_3.png";


export const industryData: Array<IndustryDataType> = [
    {
        name: "Science & Technology",
        route: "#",
        isActive: true,
        enabled:true,
        id: sectionId.SCIENCE_TECHNOLOGY,
        heading: 'Science & Technology',
        image: SCIENCE_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>The Science & Technology industry is the industry relating to the research, development,
            or distribution of technologically based goods and services.<br/><br/>This sector contains businesses
            revolving
            around the manufacturing of electronics, creation of software, computers, or products and services
            relating to information technology, and the overall improvement & creation of scientific solutions
            to a lot of technical problems in society.<br/><br/>The Science & Technology industry is one of the
            fastest-growing industries since the 20th century and has grown to encapsulate a wide
            variety of business sectors including Energy, Mining, Electronics and many more.</p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards:
            [
                {
                    image: SCIENCE_IMAGE_2,
                },
                {
                    image: SCIENCE_IMAGE_3,
                },
            ]
    },
    {
        name: "Agriculture  & Fishing",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.AGRICULTURE_FISHING,
        heading: 'Agriculture & Fishing',
        image: AGRICULTURE_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>The agriculture industry is one of the oldest and largest type of business industry. Agriculture
            industry consists of cultivating land, plants and breeding animals to produce foods and other survival
            things.
            <br/><br/>
            This industry is an integral part of every country’s economy. The modernization in the agriculture industry
            took place in the late 20th century, which is known as “Green Revolution”.
            <br/><br/>
            The evolution of farming has led to the domestication of many plants and animals, which in result, produce
            more goods and of better quality, and let us discover its various uses.

            <br/><br/>

            The fishing industry involves the catching, processing, and marketing of fish and other seafood from
            oceans, rivers, and lakes. Fishing is one of the primary forms of food production; it ranks with farming and
            probably predates it.

        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: AGRICULTURE_IMAGE_2,
            },
            {
                image: AGRICULTURE_IMAGE_3,
            },
        ]
    },
    {
        name: "Business Services",
        route: "#",
        isActive: false,
        enabled:false,
        id: sectionId.BUSINESS_SERVICES,
        heading: 'Business Services',
        image: BUSINESS_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
            'Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: BUSINESS_IMAGE_2,
            },
            {
                image: BUSINESS_IMAGE_3,
            },
        ]
    },
    {
        name: "Construction",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.CONSTRUCTION,
        heading: 'Construction',
        image: CONSTRUCTION_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>
            The construction sector is indulged in designing, building, constructing and maintaining the infrastructure.
            <br/><br/>
            The construction industry can be sub-divided into three categories such as heavy construction, general
            construction, and specialized construction.
            <br/><br/>
            Heavy construction includes the construction of bridges and roads etc.
            <br/><br/>
            General construction includes the building of residential places and commercial real estate.
            <br/><br/>
            Specialized construction includes making electric and wood things required to construct a building.
            <br/><br/>
            This era has witnessed the modernization in the way of constructing building and houses. Construction and
            related types of business industries have benefited from the advancement of technology.

        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: CONSTRUCTION_IMAGE_2,
            },
            {
                image: CONSTRUCTION_IMAGE_3,
            },
        ]
    },
    {
        name: "Food & Restaurants",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.FOOD_RESTAURANTS,
        heading: 'Food & Restaurants',
        image: FOOD_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>The food industry is an aggregation of diverse businesses which together are responsible for
            supplying food to the global population.
            <br/><br/>
            In order to produce food, the industry uses huge masses of raw material that it obtains directly from the
            farming sector. Thus, the industry is almost entirely dependent on the agriculture industry.
            <br/><br/>
            The sector encompasses everything from farming and food production, preservation, packaging, and
            distribution, to retail and catering.
            <br/><br/>
            Such a complex industry requires a wide range of skills, which in turn creates workplaces in several hundred
            occupation types.
        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: FOOD_IMAGE_2,
            },
            {
                image: FOOD_IMAGE_3,
            },
        ]

    },
    {
        name: "Hospitality Tourism & Transport",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.HOSPITALITY_TOURISM_TRANSPORT,
        heading: 'Hospitality & Tourism',
        image: TOURISM_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>The transport industry is one of the largest types of business industries. This industry deals
            with the movement of humans, things and animals by various modes of transportation.
            <br/><br/>
            The main modes of transportation are air, land (Road and Rail) and water. The transportation industry makes
            the largest part of any country’s economy.
            <br/><br/>
            The transport industry is one of the largest types of business industries. This industry deals with the
            movement of humans, things and animals by various modes of transportation.
            <br/><br/>
            The main modes of transportation are air, land (Road and Rail) and water. The transportation industry makes
            the largest part of any country’s economy.
        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: TOURISM_IMAGE_2,
            },
            {
                image: TOURISM_IMAGE_3,
            },
        ]
    },
    {
        name: "Manufacturers & Wholesalers",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.MANUFACTURERS,
        heading: 'Manufacturing',
        image: MANUFACTURER_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>
            Manufacturing is the process of converting raw material and components into the final product to sell in the
            marketplace for public consumption.
            <br/><br/>
            Manufacture industry has many categories, for example, food industry, petroleum industry, paper industry,
            wood industry, leather industry, textile mill industry, apparel industry, transportation equipment industry,
            electrical equipment industry etc.
            <br/><br/>
            Goods can be prepared in the mill, factories or plants for example fabric and goods can also be prepared by
            hands to sell in the market.
            <br/><br/>
            Manufacturing industries provide employment to educated as well as labor class population of any country.
        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: MANUFACTURER_IMAGE_2,
            },
            {
                image: MANUFACTURER_IMAGE_3,
            },
        ]
    },
    {
        name: "Health & Fitness",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.HEALTH_FITNESS,
        heading: 'Health & Fitness',
        image: FITNESS_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>
            Health care industry provides remedial, diagnostic, curative, preventive, rehabilitative, therapeutic
            services to patients and to people in their old age.
            <br/><br/>
            The main goal of this industry is to revive and maintain the health of peoples. It is one of the fastest
            growing industry. This type of business industry has great potential for investors and entrepreneurs. Every
            country’s government spends a handsome amount of money to this sector.
        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: FITNESS_IMAGE_2,
            },
            {
                image: FITNESS_IMAGE_3,
            },
        ]
    },
    {
        name: "Fashion Design",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.FASHION_DESIGN,
        heading: 'Fashion & Design',
        image: FASHION_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: <p>
            The fashion industry is unique from other industries; in that it allows for the expression of creativity,
            largely based on the functions of the individuals who comprise it. Designers, stores, factory workers,
            tailors, technically skilled embroiderers, salespersons, models, textile manufacturers, pattern makers, and
            sketch artists and predominantly culture.
            <br/><br/>
            The fashion industry consists of four levels: the production of raw materials, principally fibres and
            textiles but also leather and fur; the production of fashion goods by designers, manufacturers, contractors,
            and others; retail sales; and various forms of advertising and promotion.
            <br/><br/>
            These levels consist of many separate but interdependent sectors, all of which are devoted to the goal of
            satisfying consumer demand for apparel under conditions that enable participants in the industry to operate
            at a profit.
        </p>,
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: FASHION_IMAGE_2,
            },
            {
                image: FASHION_IMAGE_3,
            },
        ]
    },
    {
        name: "Entertainment",
        route: "#",
        isActive: false,
        enabled:true,
        id: sectionId.ENTERTAINMENT,
        heading: 'Entertainment',
        image: SCIENCE_IMAGE,
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque.',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu ' +
            'dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
            'Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        paragraphTwo:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque.',
        cards: [
            {
                image: SCIENCE_IMAGE_2,
            },
            {
                image: SCIENCE_IMAGE_3,
            },
        ]
    }
]